var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "section",
        [
          _c("section-title", {
            attrs: { title: _vm.$t("apps.inventory.message.selectwarehouse") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "col-5" }, [
              _c(
                "select",
                {
                  staticClass: "custom-select",
                  on: { change: _vm.handleChangeFromWh }
                },
                _vm._l(_vm.fromWarehouseLocations, function(bin, index) {
                  return _c(
                    "option",
                    {
                      key: index,
                      domProps: { value: bin.wh_id + "-" + bin.bin_location_id }
                    },
                    [
                      _vm._v(
                        "\n            " + _vm._s(bin.text) + "\n          "
                      )
                    ]
                  )
                }),
                0
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-2 text-center" }, [
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    top: "0px",
                    left: "0",
                    "font-size": "11px",
                    width: "100%"
                  }
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("apps.inventory.message.transferto")) +
                      " "
                  ),
                  _c("br"),
                  _vm._v(" "),
                  _c("i", { staticClass: "fas fa-long-arrow-alt-right" })
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-5" }, [
              _c(
                "select",
                {
                  staticClass: "custom-select",
                  on: { change: _vm.handleChangeToWh }
                },
                [
                  _c(
                    "option",
                    {
                      attrs: { selected: "", disabled: "" },
                      domProps: { value: -1 }
                    },
                    [_vm._v(_vm._s(_vm.$t("placeholder.select")))]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.toWarehouseLocations, function(bin, index) {
                    return _c(
                      "option",
                      {
                        key: index,
                        domProps: {
                          value: bin.wh_id + "-" + bin.bin_location_id
                        }
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(bin.text) + "\n          "
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.isSelectedToWarehouse && _vm.productsLoaded == false
        ? [
            _c("p", { staticClass: "mb-0 mt-3" }, [
              _vm._v("\n      " + _vm._s(_vm.$t("message.loading")) + "\n    ")
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.productsLoaded == true && _vm.isSelectedToWarehouse
        ? [
            _c(
              "section",
              [
                _c("section-title", {
                  attrs: { title: _vm.$t("message.item") }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row m-0" },
                  _vm._l(_vm.items, function(item, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "col-12 box mb-3" },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            {
                              class: _vm.disabledActions ? "col-12" : "col-11"
                            },
                            [
                              _c("div", { staticClass: "form-row" }, [
                                _c(
                                  "div",
                                  { staticClass: "col-6" },
                                  [
                                    _c("vue-bootstrap-autocomplete", {
                                      attrs: {
                                        data: _vm.cloneDeep(
                                          _vm.optionSkus.filter(function(opt) {
                                            return (
                                              _vm.selectedSkuIds.indexOf(
                                                opt.value
                                              ) === -1
                                            )
                                          })
                                        ),
                                        serializer: function(item) {
                                          return (
                                            item.text +
                                            " " +
                                            (item.sku_code || "")
                                          )
                                        },
                                        minMatchingChars: 1,
                                        maxMatches: 10,
                                        placeholder: _vm.$t(
                                          "placeholder.selectitem"
                                        ),
                                        loading: item.loading,
                                        disabled: _vm.disabledActions,
                                        showCreate: false,
                                        noResultsInfo: item.loaded
                                          ? _vm.$t("message.notfounddata")
                                          : null
                                      },
                                      on: {
                                        input: function($event) {
                                          _vm.items[index].loading = true
                                          _vm.lookupProducts(index, $event)
                                        },
                                        hit: function($event) {
                                          return _vm.handleSelectProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        blur: function($event) {
                                          return _vm.handleBlurProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        inputBlur: function($event) {
                                          return _vm.handleInputBlurProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        keydown: function($event) {
                                          return _vm.handleKeydownProduct(
                                            index,
                                            $event
                                          )
                                        },
                                        keyup: function($event) {
                                          return _vm.handleKeyupProduct(
                                            index,
                                            $event
                                          )
                                        }
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "suggestion",
                                            fn: function(ref) {
                                              var data = ref.data
                                              var htmlText = ref.htmlText
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex align-items-center"
                                                  },
                                                  [
                                                    _c("img", {
                                                      staticStyle: {
                                                        width: "40px",
                                                        height: "40px",
                                                        "border-radius":
                                                          "0.25rem"
                                                      },
                                                      attrs: {
                                                        src: _vm.productImage(
                                                          data.value
                                                        )
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "d-flex flex-column"
                                                      },
                                                      [
                                                        _c("span", {
                                                          staticClass: "ml-4",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              data.text
                                                            )
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass: "ml-4",
                                                          staticStyle: {
                                                            "font-size": "11px"
                                                          },
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              data.sku_code
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: item.queryProductName,
                                        callback: function($$v) {
                                          _vm.$set(
                                            item,
                                            "queryProductName",
                                            $$v
                                          )
                                        },
                                        expression: "item.queryProductName"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-6" }, [
                                  _c("div", { staticClass: "input-group" }, [
                                    _c(
                                      "div",
                                      { staticClass: "input-group-prepend" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "input-group-text" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("message.quantity"))
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: item.qty,
                                          expression: "item.qty"
                                        }
                                      ],
                                      staticClass:
                                        "form-control text-right number-only text-select-all",
                                      attrs: {
                                        disabled: item.sku_id.length == 0,
                                        type: "text"
                                      },
                                      domProps: { value: item.qty },
                                      on: {
                                        keypress: _vm.numberOnly,
                                        keyup: function($event) {
                                          item.qty = _vm.setToValidNumber(
                                            item.qty
                                          )
                                        },
                                        blur: function($event) {
                                          item.qty = _vm.setToCustomDigitsNumber(
                                            item.qty
                                          )
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            item,
                                            "qty",
                                            $event.target.value
                                          )
                                        }
                                      }
                                    })
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              item.sku_id.length > 0
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "form-row mt-2" },
                                      [
                                        _c("div", { staticClass: "col-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-prepend"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-group-text",
                                                      staticStyle: {
                                                        "border-radius":
                                                          "0.25em 0 0 0"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.fromCurrentBinLocationName
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                staticClass:
                                                  "form-control text-right",
                                                staticStyle: {
                                                  "border-left": "0",
                                                  "border-radius":
                                                    "0 0.25em 0 0"
                                                },
                                                attrs: {
                                                  disabled: true,
                                                  type: "text"
                                                },
                                                domProps: {
                                                  value: _vm.getCurrentStockByBinId(
                                                    item.sku_id,
                                                    _vm.fromWarehouseId,
                                                    _vm.selectedFromBinLocationId
                                                  )
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _vm._m(0, true),
                                              _vm._v(" "),
                                              _c("input", {
                                                staticClass:
                                                  "form-control text-right",
                                                class: _vm.getFontColor(
                                                  _vm.getCurrentStockByBinId(
                                                    item.sku_id,
                                                    _vm.fromWarehouseId,
                                                    _vm.selectedFromBinLocationId
                                                  ),
                                                  _vm.getNewCalcStock(
                                                    "-",
                                                    _vm.getCurrentStockByBinId(
                                                      item.sku_id,
                                                      _vm.fromWarehouseId,
                                                      _vm.selectedFromBinLocationId
                                                    ),
                                                    item.qty
                                                  )
                                                ),
                                                staticStyle: {
                                                  "border-left": "0px",
                                                  "border-top": "0",
                                                  "border-radius":
                                                    "0 0 0.25em 0"
                                                },
                                                attrs: {
                                                  disabled: true,
                                                  type: "text"
                                                },
                                                domProps: {
                                                  value: _vm.getCalcString(
                                                    "-",
                                                    _vm.getCurrentStockByBinId(
                                                      item.sku_id,
                                                      _vm.fromWarehouseId,
                                                      _vm.selectedFromBinLocationId
                                                    ),
                                                    item.qty
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-6" }, [
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "input-group-prepend"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "input-group-text",
                                                      staticStyle: {
                                                        "border-radius":
                                                          "0.25em 0 0 0"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.toCurrentBinLocationName
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("input", {
                                                staticClass:
                                                  "form-control text-right",
                                                staticStyle: {
                                                  "border-left": "0",
                                                  "border-radius":
                                                    "0 0.25em 0 0"
                                                },
                                                attrs: {
                                                  disabled: true,
                                                  type: "text"
                                                },
                                                domProps: {
                                                  value: _vm.getCurrentStockByBinId(
                                                    item.sku_id,
                                                    _vm.toWarehouseId,
                                                    _vm.selectedToBinLocationId
                                                  )
                                                }
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "input-group" },
                                            [
                                              _vm._m(1, true),
                                              _vm._v(" "),
                                              _c("input", {
                                                staticClass:
                                                  "form-control text-right",
                                                class: _vm.getFontColor(
                                                  _vm.getCurrentStockByBinId(
                                                    item.sku_id,
                                                    _vm.toWarehouseId,
                                                    _vm.selectedToBinLocationId
                                                  ),
                                                  _vm.getNewCalcStock(
                                                    "+",
                                                    _vm.getCurrentStockByBinId(
                                                      item.sku_id,
                                                      _vm.toWarehouseId,
                                                      _vm.selectedToBinLocationId
                                                    ),
                                                    item.qty
                                                  )
                                                ),
                                                staticStyle: {
                                                  "border-left": "0px",
                                                  "border-top": "0",
                                                  "border-radius":
                                                    "0 0 0.25em 0"
                                                },
                                                attrs: {
                                                  disabled: true,
                                                  type: "text"
                                                },
                                                domProps: {
                                                  value: _vm.getCalcString(
                                                    "+",
                                                    _vm.getCurrentStockByBinId(
                                                      item.sku_id,
                                                      _vm.toWarehouseId,
                                                      _vm.selectedToBinLocationId
                                                    ),
                                                    item.qty
                                                  )
                                                }
                                              })
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          !_vm.disabledActions
                            ? _c("div", { staticClass: "col-1 pl-0" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-block h-100",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.del(index)
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "far fa-trash-alt" })]
                                )
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  }),
                  0
                )
              ],
              1
            ),
            _vm._v(" "),
            !_vm.disabledActions
              ? _c("section", [
                  _c(
                    "button",
                    {
                      staticClass: "btn",
                      on: {
                        click: function($event) {
                          return _vm.add()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("button.addproduct")))]
                  )
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "border-top": "0px", "border-radius": "0 0 0 0.25em" }
        },
        [_c("i", { staticClass: "fas fa-sync-alt" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c(
        "span",
        {
          staticClass: "input-group-text",
          staticStyle: { "border-top": "0px", "border-radius": "0 0 0 0.25em" }
        },
        [_c("i", { staticClass: "fas fa-sync-alt" })]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-61a70f99", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61a70f99","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/inventory/stockcontrol/include/ModalTransfer.vue
// module id = null
// module chunks = 